/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uniqid from 'uniqid';
import { formatDistance } from '../../lib/ConversionUtils';
import { i18n } from '../../lib/Utils';

// components
import {
  Selector,
  SelectorItem,
  SelectorVariant,
} from '../../components/Vehicle';

// actions
import {
  updateVehicle,
  toggleVehicleMenu,
} from '../../reducers/Vehicle/actions';
import { getRoute } from '../../reducers/RouteBtn/actions';
import { updateGasSavings } from '../../reducers/GasSavings/actions';
import { setFocusedPlaces } from '../../reducers/Places/actions';

class Vehicle extends Component {
  constructor(props) {
    super(props);

    this.toggleVehicleSelector = this.toggleVehicleSelector.bind(this);
    this.toggleMobileVehicleSelector = this.toggleMobileVehicleSelector.bind(
      this,
    );
    this.handleDoneBtnClick = this.handleDoneBtnClick.bind(this);
    this.setVehicle = this.setVehicle.bind(this);

    this.state = {
      selected: 'MS_2017_100D',
    };
  }

  getStyles() {
    const { animationName, translateX, animationTimeout } = this.props;

    let styles = {};
    if (animationName) {
      styles = {
        transform: `${translateX}`,
        animation: `${animationName} .${animationTimeout}s 1`,
      };
    }

    return styles;
  }

  setVehicle(e) {
    const node = e.currentTarget;
    this.setState({ selected: node.dataset.model });
    if (node) {
      this.props.dispatchUpdateVehicle(node);
    }
  }

  toggleVehicleSelector() {
    const { toggle } = this.props;
    this.props.dispatchToggleVehicleMenu(!toggle);
    this.props.dispatchSetPlacesFocused('');
  }

  toggleMobileVehicleSelector() {
    const { toggle } = this.props;
    this.props.dispatchToggleVehicleMenu(!toggle);
  }

  handleDoneBtnClick() {
    const {
      fields,
      directionsLoaded,
      vehicle,
      countryCode,
      toggle,
    } = this.props;

    this.props.dispatchToggleVehicleMenu(!toggle);

    if (directionsLoaded) {
      this.props.dispatchGetRoute(fields, vehicle);
      this.props.dispatchUpdateGasSavings(countryCode, vehicle.modelCode);
    }
  }

  renderVehicleVariant(variants, lastItem) {
    const { disclaimer, locale, options, unit } = this.props;
    const { selected } = this.state;

    const vehicleLength = variants.length - 1;
    return variants.map((variant, index) => {
      const last = lastItem && vehicleLength === index;
      const variantObj = options[variant.optionAPICode];

      if (variantObj) {
        let rangeValue = variantObj.range;

        if (variantObj.overrides && variantObj.overrides[0] && variantObj.overrides[0].content && variantObj.overrides[0].content.range) {
          rangeValue = variantObj.overrides[0].content.range;
        }
        return (
          <SelectorVariant
            handleClick={this.setVehicle}
            selected={variant.model === selected}
            key={uniqid()}
            last={last}
            disclaimer={i18n(disclaimer, { 'DISTANCE': unit.distance.default.plural, 'LOCAL_EPA': unit.localEPA})}
            {...variant}
            rangeValue={formatDistance(
              parseInt(rangeValue, 10),
              unit,
              locale,
            )}
          />
        );
      }
    });
  }

  renderSelector() {
    const { vehicles, isMobile } = this.props;
    const vehiclesLength = Object.keys(vehicles).length - 1;
    const styles = this.getStyles();

    return (
      <Selector
        styles={styles}
        handleClick={this.toggleVehicleSelector}
        handleBtnClick={this.handleDoneBtnClick}
        {...this.props}
      >
        {isMobile && this.renderSelectorHeading()}
        {Object.keys(vehicles).map((vehicle, index) => {
          const lastItem = index === vehiclesLength;
          const firstVariant = vehicles[vehicle][0];

          return (
            <SelectorItem
              modelCode={firstVariant.modelCode}
              longName={firstVariant.longName}
              driveTrain={firstVariant.driveTrain}
              key={uniqid()}
            >
              {this.renderVehicleVariant(vehicles[vehicle], lastItem)}
            </SelectorItem>
          );
        })}
      </Selector>
    );
  }

  renderSelectorHeading() {
    const { selectorLabel, isMobile } = this.props;

    return (
      <SelectorItem
        isMobile={isMobile}
        longName={selectorLabel}
        handleClick={this.toggleMobileVehicleSelector}
      />
    );
  }

  render() {
    const { vehicles } = this.props;

    if (Object.keys(vehicles).length > 0) return this.renderSelector();

    return null;
  }
}

Vehicle.propTypes = {
  dispatchUpdateVehicle: PropTypes.func.isRequired, // Lets the application know what vehicle is selected
  dispatchToggleVehicleMenu: PropTypes.func.isRequired, // Lets the application know the menu is toggled
  toggle: PropTypes.bool.isRequired, // The state of the vehicle menu
  isMobile: PropTypes.bool.isRequired, // True when the app is loaded on a handheld sized device
  vehicle: PropTypes.shape({}).isRequired, // Vehicle information
  vehicles: PropTypes.shape().isRequired, // Vehicle meta data
  fields: PropTypes.arrayOf(PropTypes.object).isRequired, // Contains objects with information about each input field & location
  directionsLoaded: PropTypes.bool.isRequired, // If the directions have successfully returned from API
  dispatchGetRoute: PropTypes.func.isRequired, // Passes trip details to routing service
  model: PropTypes.string.isRequired, // Vehicle model
  selectorLabel: PropTypes.string.isRequired, // Vehicle selector lable when on mobile devices
  dispatchUpdateGasSavings: PropTypes.func.isRequired, // Fetches Fuel efficiency data from API
  countryCode: PropTypes.string.isRequired, // Short country code [US]
  animationName: PropTypes.string.isRequired, // Name of the animation applied to elements
  translateX: PropTypes.string.isRequired, // translateX CSS property for animation
  animationTimeout: PropTypes.number.isRequired, // duration of animation
  dispatchSetPlacesFocused: PropTypes.func.isRequired, // Dispatches currently focused input field
  disclaimer: PropTypes.string.isRequired, // Vehicle range disclaimer
  editing: PropTypes.bool.isRequired, // If the route is being edited
};

// Vehicle.defaultProps = VehicleDefaultProps;

const mapStateToProps = state => ({
  locale: state.App.locale,
  longName: state.Vehicle.longName,
  modelCode: state.Vehicle.modelCode,
  model: state.Vehicle.model,
  options: state.Vehicle.options,
  shortName: state.Vehicle.shortName,
  toggle: state.Vehicle.toggle,
  unit: state.App.unit,
  vehicle: state.Vehicle,
  vehicles: state.Vehicle.vehicles,
  selectorLabel: state.Vehicle.label,
  name: state.Vehicle.name,
  disclaimer: state.Vehicle.disclaimer,
  isMobile: state.App.isMobile,
  fields: state.Places.fields,
  directionsLoaded: state.Directions.directionsLoaded,
  countryCode: state.GoogleMap.region,
  animationName: state.DestinationChargers.animationName,
  translateX: state.DestinationChargers.translateX,
  animationTimeout: state.DestinationChargers.animationTimeout,
  editing: state.Places.editing,
  windowHeight: state.App.windowHeight,
  btnLabel: state.Vehicle.btnLabel,
  isLoading: state.App.isLoading,
  componentHeights: state.App.componentHeights,
});

const mapDispatchToProps = dispatch => ({
  dispatchUpdateVehicle: vehicle => {
    if (vehicle) {
      dispatch(updateVehicle(vehicle));
    }
  },
  dispatchToggleVehicleMenu: toggle => {
    dispatch(toggleVehicleMenu(toggle));
  },
  dispatchGetRoute: (fields, vehicle) => {
    dispatch(getRoute(fields, vehicle));
  },
  dispatchUpdateGasSavings: (countryCode, modelCode) => {
    dispatch(updateGasSavings(countryCode, modelCode.toLowerCase()));
  },
  dispatchSetPlacesFocused: focused => {
    dispatch(setFocusedPlaces(focused));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Vehicle);
